module.exports = __webpack_public_path__ + "static/media/Choir1.6449b7e8.jpg";